/* eslint-disable @typescript-eslint/no-namespace, no-redeclare, no-inner-declarations */

import { User } from '../models/user.model';

export enum SiteRole {
  Public = 'public',
  User = 'user',
  SecurityChampion = 'security_champion',
  Developer = 'developer',
  SiteAdmin = 'site_admin',
  Drone = 'drone',
}

export namespace SiteRole {
  export function getPrimaryRole(user: User): SiteRole {
    if (user.roles instanceof Array) {
      const roles = new Set(user.roles);
      if (roles.has(SiteRole.SiteAdmin)) {
        return SiteRole.SiteAdmin;
      }
      if (roles.has(SiteRole.Developer)) {
        return SiteRole.Developer;
      }
      // security_champion carries the same privileges as user, so on its own it still reads as one
      if (roles.has(SiteRole.User) || roles.has(SiteRole.SecurityChampion)) {
        return SiteRole.User;
      }
      return SiteRole.Public;
    }
    // fall back to `root` flag
    return user.root ? SiteRole.SiteAdmin : SiteRole.User;
  }

  export function isSiteAdmin(user?: User): boolean {
    return user ? getPrimaryRole(user) === SiteRole.SiteAdmin : false;
  }

  export function isDeveloper(user: User): boolean {
    return getPrimaryRole(user) === SiteRole.Developer;
  }
}
